// frontend_react/src/pages/Home.jsx

import "../styles/home.css";
import queensLogo from "../assets/queens_logo.svg";
import StoreLinkCard from "../components/home/StoreLinkCard";
import LoginCard from "../components/home/LoginCard";
import EventsCard from "../components/home/EventsCard";
import NewsletterCard from "../components/home/NewsletterCard";

function Home() {

  return (
    <div className="flex w-full min-h-screen">
      <main className="flex-1 flex-col items-center">
        <div className="w-full main_home_container">
          <h1
            className="font-size-title bold m-md text-align-center"
            style={{ marginLeft: 0 }}
          >
            QUEEN'S GAMES
          </h1>

          <div className="grid grid-cols-3 gap-md w-full">
            <div className="relative h-100 w-full">
              <img src={queensLogo} alt="" className="white_svg logo-barrette" />
              <StoreLinkCard />
            </div>

            <LoginCard />
            <EventsCard />
            <NewsletterCard />
          </div>
        </div>
      </main>
    </div>
  );
}

export default Home;